<template>
</template>

<script>

export default {
	name: 'oauth2-callback'
}
</script>
